var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-1",
    transform: "translate(-3230.000000, -885.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb",
    transform: "translate(3230.000000, 885.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0000068,17.4999863 C35.0000068,7.83499609 27.1649629,-1.3671875e-05 17.5000068,-1.3671875e-05 C7.8350166,-1.3671875e-05 6.8359375e-06,7.83499609 6.8359375e-06,17.4999863 C6.8359375e-06,26.2347764 6.39950391,33.4745469 14.7656318,34.7873203 L14.7656318,22.5585801 L10.3222725,22.5585801 L10.3222725,17.4999863 L14.7656318,17.4999863 L14.7656318,13.6445176 C14.7656318,9.25858008 17.3782588,6.83592383 21.3756074,6.83592383 C23.2902852,6.83592383 25.2929756,7.1777207 25.2929756,7.1777207 L25.2929756,11.4843613 L23.0862324,11.4843613 C20.9123359,11.4843613 20.2343818,12.8333311 20.2343818,14.2173008 L20.2343818,17.4999863 L25.0878975,17.4999863 L24.3120186,22.5585801 L20.2343818,22.5585801 L20.2343818,34.7873203 C28.6004756,33.4745469 35.0000068,26.2347764 35.0000068,17.4999863",
    id: "Fill-1",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3120117,22.5585801 L25.0878906,17.4999863 L20.234375,17.4999863 L20.234375,14.2173008 C20.234375,12.8333311 20.9123291,11.4843613 23.0862256,11.4843613 L25.2929688,11.4843613 L25.2929688,7.1777207 C25.2929688,7.1777207 23.2902783,6.83592383 21.3756006,6.83592383 C17.3782861,6.83592383 14.765625,9.25858008 14.765625,13.6445176 L14.765625,17.4999863 L10.3222656,17.4999863 L10.3222656,22.5585801 L14.765625,22.5585801 L14.765625,34.7873203 C15.6565869,34.9271152 16.5697656,34.9999863 17.5,34.9999863 C18.4302344,34.9999863 19.3434131,34.9271152 20.234375,34.7873203 L20.234375,22.5585801 L24.3120117,22.5585801 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.6150542499ec14affddb6031d62cce0a.svg";
export { ForwardRef as ReactComponent };